import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getArticleById } from '../components/articles';

const ArticlePage = () => {
  const { articleId } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = () => {
      // Simulate API call delay
      setTimeout(() => {
        const foundArticle = getArticleById(articleId);
        setArticle(foundArticle);
        setLoading(false);
      }, 500);
    };

    fetchArticle();
  }, [articleId]);

  if (loading) {
    return (
      <div className="article-loading">
        <div className="loading-spinner"></div>
        <p>Loading article...</p>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="article-not-found">
        <h1>Article Not Found</h1>
        <p>The article you're looking for doesn't exist.</p>
        <Link to="/blog" className="btn-primary">← Back to Blog</Link>
      </div>
    );
  }

  return (
    <div className="article-page">
      <div className="article-container">
        <div className="article-header">
          <Link to="/blog" className="back-link">← Back to Blog</Link>
          <div className="article-meta">
            <span className="article-date">{new Date(article.date).toLocaleDateString()}</span>
            <span className="article-read-time">{article.readTime}</span>
          </div>
          <h2 className="article-title">{article.title}</h2>
          <div className="article-author">By {article.author}</div>
        </div>
        
        <div className="article-content">
          <div className="article-image-article-page">
            <img src={article.image} alt={article.title} />
          </div>
          <div className="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />
        </div>
        
        <div className="article-footer">
          <Link to="/blog" className="btn-primary">← Back to Blog</Link>
        </div>
      </div>
    </div>
  );
};

export default ArticlePage;
